import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function FiltersFooter(props) {
    return jsx(Wrapper, Object.assign({}, props));
}
const Wrapper = styled("div")(({ theme }) => ({
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(3),
    gap: theme.spacing(2),
}));

export { FiltersFooter };
//# sourceMappingURL=FiltersFooter.js.map
